import { render, staticRenderFns } from "./TrangTaoDanhMucHeThong.vue?vue&type=template&id=4d4d2116&"
import script from "./TrangTaoDanhMucHeThong.vue?vue&type=script&lang=js&"
export * from "./TrangTaoDanhMucHeThong.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports